module.exports = __webpack_public_path__ + "media/images/emblems/Rifferswil-4243dc919d8f3b540884a7d589e0dc5e.svg";